
import {$authHost, $host} from "./index";

export const addToBasket = async (item,userId,currentSize) => {
    const {data} = await $authHost.post('api/basket/addproducttobasket',{item,userId,currentSize})
    return data;
}

export const transferPreorderToBasket = async (item, userId, currentSize, quantity, transferKey) => {
    const {data} = await $authHost.post('api/basket/transferpreordertobasket',
        {item, userId, currentSize, quantity, transferKey})
    return data;
}

export const getAndMergeBasketItems = async (id,basketItems) => {
    const {data} = await $authHost.post('api/basket/getandmergebasketitems', {id,basketItems})
    return data;
}

export const mergeBasketItemsNoUser = async (basketItems) => {
    let payload;
    try {
        if (basketItems === null || basketItems === undefined || basketItems === '') {
            payload = '[]';
        } else if (Array.isArray(basketItems)) {
            payload = JSON.stringify(basketItems);
        } else if (typeof basketItems === 'string' && Array.isArray(JSON.parse(basketItems))) {
            payload = basketItems;
        } else {
            throw new Error();
        }
    } catch (error) {
        throw new Error('Не удалось проверить сохранённую корзину.');
    }
    const {data} = await $host.post('api/basket/mergebasketitems', {basketItems: payload})
    return data;
}

// A legacy line key is synthesized by the browser for rendering. The owned
// basket API accepts only persisted `basket:<id>` keys; send the exact item
// identity instead for legacy count/remove/clear mutations.
const basketMutationItem = item => {
    if (item && typeof item === 'object' && !Array.isArray(item) &&
        typeof item.lineKey === 'string' && item.lineKey.startsWith('legacy:')) {
        const {lineKey, ...identity} = item;
        return identity;
    }
    return item;
};

export const updateCountItemsBasket = async (modifier, item, userId) => {
    if(item.count === 1 && modifier === "decrease") {
        return false;
    }

    const {data} = await $authHost.post('api/basket/updatecountitems',{modifier,item: basketMutationItem(item),userId})

    return data;
}

export const deleteBaseBasketOneItem = async (item,userId) => {

    const {data} = await $authHost.post('api/basket/deleteoneitembasket', {item: basketMutationItem(item),userId})

    return data;

}

export const deleteAllBasketItems = async (items, userId) => {
    const {data} = await $authHost.post('/api/basket/clearallbasketitems',{items: Array.isArray(items) ? items.map(basketMutationItem) : items, userId})

    return  data;
}

export const forceDeleteAllBasketItems = async (userId) => {
    const {data} = await $authHost.post('/api/basket/clearallbasketitems',{userId})

    return  data;
}

export const helpFindCity = async (cityName) => {
    const {data} = await $host.post('/api/basket/supportfindcity',{cityName})

    return  data;
}

export const findDeliveryForOrder = async (item, giftOnly) => {
    const {data} = await $host.post('/api/basket/finddeliveryfororder', {item, giftOnly})

    return data;
}

export const getDeliveries = async (address, giftOnly) => {
    const {data} = await $host.post('/api/basket/deliveries', { address, giftOnly })

    return data;
}

export const sdekGetCityOffice = async (cityInfo) => {
    const {data} = await $host.post("/api/basket/sdekgetcity",{cityInfo});
    return data;
}

export const yandexGetCityOffice = async (cityInfo) => {
    const {data} = await $host.post("/api/basket/yandexgetcity",{cityInfo});
    return data;
}

export const samGetCityOffice = async (cityInfo) => {
    const {data} = await $host.post("/api/basket/samgetcity",{cityInfo});
    return data;
}

export const getDeliveryPoint = async (cityInfo) => {
    const {data} = await $host.post("/api/basket/getDeliveryPoint",{cityInfo});
    return data;
}

export const yandexGetCostToOffice = async (office_id, priceNoSell) => {
    const {data} = await $host.post("/api/basket/yandexgetcost", {office_id, priceNoSell});
    return data;
}

export const getDeliveryAddress = async (city, value) => {
    const {data} = await $host.post('/api/basket/getdeliveryaddress', {city, value});
    return data;
}

export const fetchReverseGeocode = async (query) => {
    const {data} = await $host.post('/api/basket/reversegeocode', {query});
    return data;
}

export const getDeliveryToDoorPrice = async (value, type, priceNoSell) => {
    const {data} = await  $host.post('/api/basket/gettodoorprice',{value, type, priceNoSell});
    return data;
}

export const getCourierDeliveryCost = async (address, type, priceNoSell) => {
    const { data } = await  $host.post('/api/basket/courier-delivery-cost',{address, priceNoSell});
    return data;
}

export const getPaymentMethodsById = async (idArray, hasGift = false) => {
    const {data} = await $host.post('/api/basket/getpaymentsbyid', {idArray, hasGift})
    return data;
}

export const searchPromocodeAndActive = async (promocode,user, basketSumm) => {
    const {data} = await $host.post('/api/basket/searchpromocode',{promocode,user, basketSumm})
    return  data;
}

//#####################     LocalStorage Basket Function    #####################//
export const priceToUserString = (price) => {
    price = round(price, 1)
    let stringPrice = String(price);
    return stringPrice.replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ');
}

// Only the server-owned pricing UI uses this path. Preserve the legacy
// one-decimal formatter above for its existing consumers.
export const priceToUserStringExact = price => {
    const minor = Math.round(price * 100);
    if (typeof price !== 'number' || !Number.isFinite(price) || price < 0 || !Number.isSafeInteger(minor) || Math.abs(minor / 100 - price) > 1e-9) return '—';
    const whole = String(Math.floor(minor / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ' '), cents = minor % 100;
    return cents ? whole + '.' + String(cents).padStart(2, '0') : whole;
}

export const isUsePromocode = (item, categoryArray, productsArray) => {
    let result = true;
    let categoriesArrayOneProduct = item.item.product.product_category;
    if(categoryArray.length) {
        for(let oneCategoryProduct of categoriesArrayOneProduct) {
            if (!categoryArray.find(element => element.id === oneCategoryProduct)) {
                result = false;
            } else {
                result = true;
                break;
            }
        }
    }

    if(result === false) {
        //не получил скидки по категории.
    }

    if(productsArray.length && result) {
        if (!productsArray.find(element => element.id === item.item.id)) {
            result = false;
        }
    }
    return result;
}

export const calculateBasket = async (items, delivery, delPrice, promo, payment, user, bonusesAmount, ownedOptions) => {
    try {
        if (ownedOptions !== undefined && !['authenticated', 'guest'].includes(ownedOptions?.authScope)) return null;
        if (ownedOptions !== undefined) {
            const body = {items, delivery, promo, payment, bonusesAmount,
                ...(ownedOptions.shippingContext ? {shippingContext: ownedOptions.shippingContext} : {})};
            const client = ownedOptions.authScope === 'guest' ? $host : $authHost;
            const {data} = await client.post('/api/basket/calculatebasket', body);
            return data;
        }
        const {data} = await $host.post('/api/basket/calculatebasket', {items, delivery, delPrice, promo, payment, user, bonusesAmount})
        return data;
    } catch(error) {
        return null
    }
}

export const checkBasketItems = async (items) => {
    const {data} = await $host.post('api/basket/checkbasketitems', {items})
    return data;
}

export const mindboxSetCart = async (deviceUUID, userAgent, productList) => {
    const {data} = await $host.post('api/basket/mindboxsetcart',{deviceUUID, userAgent, productList})
    return data;
}

export const round = (value, precision) => {
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
}

export const mindboxGetRecommend = async (deviceUUID, userAgent) => {
    const {data} = await $host.post('api/basket/mindboxgetrecommend',{deviceUUID, userAgent})
    return data;
}
